export default __webpack_public_path__ + "static/Ed-99e1ab9a1a5153d893c9ab2ed886d81224485b674106e7e746d5411e64fbd9b1.svg";